import { useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, ArrowRight, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const CheckpointCard = ({ check, onPick, onNext }) => {
  const { L } = useLang();
  const [sending, setSending] = useState(false);
  const r = check.result;
  const pick = async (i) => { if (r || sending) return; setSending(true); try { await onPick(i); } finally { setSending(false); } };
  const tone = (i) => !r ? "border-white/15 hover:border-[#5EEAD4] hover:bg-white/5" : i === r.answer ? "border-[#14B8A6] bg-[#14B8A6]/15" : i === r.pick ? "border-[#FF6B6B] bg-[#FF3B3B]/10" : "border-white/10 opacity-60";
  return (
    <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} data-testid="live-check">
      <div className="text-[11px] font-black uppercase tracking-[0.2em] text-[#FBBF24]">{check.title}</div>
      <h2 className="mt-2 text-2xl sm:text-3xl font-extrabold text-white leading-tight" data-testid="live-check-question">{check.question}</h2>
      <div className="mt-5 grid sm:grid-cols-2 gap-2.5">
        {check.options.map((o, i) => (
          <button key={i} type="button" disabled={Boolean(r) || sending} onClick={() => pick(i)} data-testid={`live-check-option-${i}`}
            className={`text-left rounded-2xl border-2 px-4 py-3 text-[15px] font-semibold text-white transition-colors ${tone(i)}`}>
            <span className="mr-2 text-[#5EEAD4]">{String.fromCharCode(65 + i)}.</span>{o}
          </button>
        ))}
      </div>
      {sending && <Loader2 className="mt-4 w-5 h-5 animate-spin text-[#5EEAD4]" />}
      {r && (
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="mt-5 rounded-2xl bg-white/5 border border-white/10 p-4" data-testid="live-check-feedback">
          <div className={`flex items-center gap-2 font-extrabold ${r.correct ? "text-[#5EEAD4]" : "text-[#FFB4B4]"}`} data-testid="live-check-verdict">
            {r.correct ? <CheckCircle2 className="w-5 h-5" /> : <XCircle className="w-5 h-5" />}{r.correct ? L("Correct, well done!", "सही जवाब, शाबाश!") : L("Not quite. Here's why:", "थोड़ा चूक गए। ऐसे समझिए:")}
          </div>
          <p className="mt-2 text-sm text-slate-300 leading-relaxed">{r.explain}</p>
          <button type="button" onClick={onNext} data-testid="live-check-continue"
            className="mt-4 h-11 px-5 rounded-full bg-[#14B8A6] text-[#0B1F3A] font-black inline-flex items-center gap-2 hover:bg-white transition-colors">{L("Continue lecture", "लेक्चर आगे बढ़ाएँ")}<ArrowRight className="w-4 h-4" /></button>
        </motion.div>
      )}
    </motion.div>
  );
};
